import { render, staticRenderFns } from "./SubIBs.vue?vue&type=template&id=10e51c1e&"
import script from "./SubIBs.vue?vue&type=script&lang=js&"
export * from "./SubIBs.vue?vue&type=script&lang=js&"
import style0 from "./SubIBs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports